import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

export const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle'); // idle | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setStatus('idle');
    try {
      await sendPasswordResetEmail(auth, email, {
        url: `${window.location.origin}/reset-password/confirm`,
        handleCodeInApp: true,
      });
      setStatus('success');
      setMessage('Password reset email sent. Please check your inbox.');
    } catch (err) {
      setStatus('error');
      if (err.code === 'auth/user-not-found') {
        setMessage('No account found for that email.');
      } else if (err.code === 'auth/invalid-email') {
        setMessage('Please enter a valid email address.');
      } else {
        setMessage('Unable to send reset email. Please try again later.');
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh]">
      <h2 className="heading-primary-1 text-4xl font-extrabold text-center mb-6">Forgot Password</h2>
      <p className="text-lg text mb-6 text-center">
        Enter your account email and we'll send you a reset link.
      </p>
      <form onSubmit={handleSubmit} className="w-full max-w-sm card p-8 rounded-lg shadow-md">
        <div className="mb-4">
          <label htmlFor="email" className="block text-muted text-sm font-bold mb-2">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-field"
            placeholder="you@example.com"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-full">
          Send Reset Link
        </button>
        {message && (
          <p className={`text-sm mt-4 text-center ${status === 'success' ? 'text-success' : 'text-danger'}`}>{message}</p>
        )}
      </form>
    </div>
  );
};
